// extracted by mini-css-extract-plugin
export default {"body":"activeFeedback__body__Qi8AD","slideIn":"activeFeedback__slideIn__STLd6"};